

/**
 * @ngdoc filter
 * @name app.filter:queryOrderBy
 * @function
 * @description
 * # queryOrderBy
 * Filter in the app.
 */
angular.module('app')
	.filter('queryOrderBy', /* @ngInject */ function ($parse) {
		const processPredicates = sortPredicates => sortPredicates.map(predicate => {
			let descending = 1, get = angular.identity;

			if (angular.isFunction(predicate)) {
				get = predicate;
			}
			else if (angular.isString(predicate)) {
				if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
					descending = predicate.charAt(0) === '-' ? -1 : 1;
					predicate = predicate.substring(1);
				}
				if (predicate !== '') {
					get = $parse(predicate);
					if (get.constant) {
						const key = get();
						get = value => value[key];
					}
				}
			}
			return { get: get, descending: descending };
		});

		const getPredicateValue = (value, index) => {
			let type = typeof value;

			if (value === null) {
				type = 'null';
			}
			else if (type === 'object') {
				value = angular.isArray(value) ? value[0] : value;
				if (angular.isObject(value) && 'name' in value) {
					value = value.name;
				}
				if (angular.isDefined(value)) {
					type = 'string';
				}
			}
			return { value: value, type: type, index: index };
		};

		const defaultCompare = (v1, v2) => {
			let result = 0;
			const type1 = v1.type;
			const type2 = v2.type;

			if (type1 === type2) {
				let value1 = v1.value;
				let value2 = v2.value;

				if (type1 === 'string') {
					// Compare strings case-insensitively
					if (angular.isString(value1) && angular.isString(value2)) {
						value1 = value1.toLowerCase();
						value2 = value2.toLowerCase();
					}
				}
				else if (type1 === 'object') {
					// For basic objects, use the position of the object
					// in the collection instead of the value
					if (angular.isObject(value1)) {
						value1 = v1.index;
					}
					if (angular.isObject(value2)) {
						value2 = v2.index;
					}
				}

				if (value1 !== value2) {
					result = value1 < value2 ? -1 : 1;
				}
			}
			else {
				result = (type1 === 'undefined') ? 1 :
					(type2 === 'undefined') ? -1 :
						(type1 === 'null') ? 1 :
							(type2 === 'null') ? -1 :
								(type1 < type2) ? -1 : 1;
			}

			return result;
		};

		return (array, sortPredicate, reverseOrder, compareFn) => {
			if (array === null) {
				return array;
			}

			if (!angular.isArray(array)) {
				throw Error('Not an array!');
			}

			if (!angular.isArray(sortPredicate)) {
				sortPredicate = [sortPredicate];
			}

			if (sortPredicate.length === 0) {
				sortPredicate = ['+'];
			}

			const predicates = processPredicates(sortPredicate);

			const descending = reverseOrder ? -1 : 1;

			// Define the `compare()` function. Use a default comparator if none is specified.
			const compare = angular.isFunction(compareFn) ? compareFn : defaultCompare;

			const getComparisonObject = (value, index) => {
				// NOTE: We are adding an extra `tieBreaker` value based on the element's index.
				// This will be used to keep the sort stable when none of the input predicates can
				// distinguish between two elements.
				return {
					value:           value,
					tieBreaker:      { value: index, type: 'number', index: index },
					predicateValues: predicates.map(predicate => getPredicateValue(predicate.get(value), index)),
				};
			};

			const doComparison = (v1, v2) => {
				let i = 0;
				const ii = predicates.length;
				for (; i < ii; i++) {
					const result = compare(v1.predicateValues[i], v2.predicateValues[i]);
					if (result) {
						return result * predicates[i].descending * descending;
					}
				}

				return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
			};

			// The next three lines are a version of a Swartzian Transform idiom from Perl
			// (sometimes called the Decorate-Sort-Undecorate idiom)
			// See https://en.wikipedia.org/wiki/Schwartzian_transform
			const compareValues = Array.prototype.map.call(array, getComparisonObject);
			compareValues.sort(doComparison);
			array = compareValues.map(item => item.value);

			return array;
		};
	});
